
import { edit } from "@/api/information"
import Header from "@/components/Header/index.vue";
import Banner from "./Banner.vue"
import Works from "@/components/Works/index.vue"
import WithdrawlRecord from "@/components/WithdrawalRecord/index.vue"
import { defineComponent, reactive, toRefs, ref } from 'vue';
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
declare const window: any;
export default defineComponent({
  components:{
      Header,
      Banner,
      Works,
      WithdrawlRecord
  },
  setup(){
    const validatePass = (rule:any, value:string, callback:any) => {
      if (value === '') {
        callback(new Error('Required'));
      } else {
        if (data.form.checkPass !== '') {
          data.ruleForm.validateField('checkPass');
        }
        callback();
      }
    };
    const validatePass2 = (rule:any, value:string, callback:any) => {
      if (value === '') {
        data.paypalFlag = false
        callback(new Error('Required'));
      } else if (value !== data.form.paypalAccount) {
          data.paypalFlag = false
        callback(new Error('The two paypalAccount are inconsistent!'));
      } else {
          data.paypalFlag = true
        callback();
      }
    };
    const validatePhoneNum = (rule:any, value:string, callback:any) => {
      if (value === '') {
        data.phoneFlag = false
        callback(new Error('Required'));
      } else {
        data.phoneFlag = true
        callback();
      }
    };
    // const router = useRouter()
    
    interface DataProps{
      form:{
        firstName: string,
        lastName: string,
        email: string,
        paypalAccount: string,
        checkPass: string,
        phoneNum: string,
        joinReason: string,
        goodFit: string,
        checkedA:boolean,
        checkedB:boolean,
        checkedC:boolean
      },
      ruleForm: any,
      phoneFlag: boolean,
      paypalFlag: boolean,
      dialogTableVisible: boolean,
      submitBtnDisabled: boolean
    }
    const data:DataProps = reactive({
        submitBtnDisabled: true,
        paypalFlag: true,
        phoneFlag: true,
        dialogTableVisible: false,
        ruleForm: ref(null),
        form:{
            firstName: '',
            lastName: '',
            email: '',
            paypalAccount: '',
            checkPass: '',
            phoneNum: '',
            joinReason: '',
            goodFit: '',
            checkedA:false,
            checkedB:false,
            checkedC:false
        },
        rules:{
            firstName: [{ required: true, message: 'Required', trigger: 'blur' }],
            lastName: [{ required: true, message: 'Required', trigger: 'blur' }],
            email: [{ required: true, message: 'Required', trigger: 'blur' }],
            paypalAccount: [{ validator: validatePass, trigger: 'blur' }],
            checkPass: [{ validator: validatePass2, trigger: 'blur' }],
            phoneNum: [{ validator: validatePhoneNum, trigger: 'blur' }],
            joinReason: [{ required: true, message: 'Required', trigger: 'blur' }],
            goodFit: [{ required: true, message: 'Required', trigger: 'blur' }],
        },
        flag:true,
        submit:()=>{
            data.ruleForm.validate((valid:boolean)=>{
                if (valid) {
                    if(!data.form.checkedA || !data.form.checkedB || !data.form.checkedC){
                        ElMessage.error('Please check')
                        return false
                    }
                    edit(data.form).then(res=>{
                        const result = res as any
                        if(result.code === 200){
                            ElMessage.success('ok')
                            data.dialogTableVisible = true
                        }else{
                            ElMessage.error(result.msg)
                        }
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            })
        },
        goNonda:()=>{
            window.open('https://www.nonda.co',"_blank")
        },
        handleCheckd:(val:boolean)=>{
            if(data.form.checkedA && data.form.checkedB && data.form.checkedC){
                data.submitBtnDisabled = false
            }else{
                data.submitBtnDisabled = true
            }
            console.log(val)
        }

    })
    const refData = toRefs(data)
    return {
      ...refData
    }
  }
  
})
